import { useNavigate, useParams } from 'react-router';

import { Alert } from '@app-velocity/ui';

import { ArrowForwardIcon } from '@app-velocity/icons';

import { useI18n } from '@app-velocity/i18n';

import { useAIReviewStatusContext } from '../../hooks/useAIReviewStatusContext';
import { useScenarioDetailsContext } from '../../../../hooks/useScenarioDetailsContext';
import { ScenarioRoutePaths } from '../../../../routes/ScenariosRoutePaths';

export const ActionTestWithHumans = () => {
  const { t } = useI18n();
  const { teamId, workspaceId } = useParams<{
    teamId: string;
    workspaceId: string;
  }>();
  const { review } = useAIReviewStatusContext();
  const { scenario } = useScenarioDetailsContext();
  const navigate = useNavigate();

  const goToHumanTestingSetUp = () => {
    if (!scenario || !scenario.id || !workspaceId || !teamId) return;

    navigate(
      ScenarioRoutePaths.setUpHumanTesting(teamId, workspaceId, scenario.id)
    );
  };

  if (review.reviewStatus !== 'COMPLETED' || scenario.finalTriggerElement)
    return null;

  return (
    <Alert.ActionButton status="success" onClick={goToHumanTestingSetUp}>
      {t('prototypes:now_test_with_humans')} <ArrowForwardIcon />
    </Alert.ActionButton>
  );
};
